import * as actionTypes from 'modules/appointments/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = null;

const clearError = () => null;
const hasError = (_, { payload }) => payload.message;

export default createReducer(initialState, {
  [actionTypes.FETCH_ATTENTION_POINTS_REQUEST]: clearError,
  [actionTypes.FETCH_ATTENTION_POINTS_FAILURE]: hasError,
});
